export enum QuickBookSyncStatus {
  Synced = "Synced",
  NotSynced = "NotSynced",
  Failed = "Failed",
  PartialSync = "PartialSync",
}
